import types from "./types";


export const getLabPackages = (pageNum, search, filterby, limit) => ({
    type: types.GET_LAB_PACKAGE,
    pageNum,
    search,
    filterby,
    limit
})

